export const ScheduledMeeting = [
  {
    "specificSlot": {
      "startTime": "2026-02-12T09:15:00.000Z",
      "endTime": "2026-02-12T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593767", 
    "slotSelectionType": "specific",
    "status":'confirmed'
  },
  {
    "specificSlot": {
      "startTime": "2026-02-12T09:15:00.000Z",
      "endTime": "2026-02-12T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593761", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2026-02-20T09:15:00.000Z",
      "endTime": "2026-02-20T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593762", 
    "slotSelectionType": "specific",
    "status":'confirmed'
  },
  {
    "specificSlot": {
      "startTime": "2026-02-21T09:15:00.000Z",
      "endTime": "2026-02-21T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593763", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2026-02-22T09:15:00.000Z",
      "endTime": "2026-02-22T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593764", 
    "slotSelectionType": "specific",
    "status":'confirmed'
  },
  {
    "specificSlot": {
      "startTime": "2026-02-23T09:15:00.000Z",
      "endTime": "2026-02-23T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593765", 
    "slotSelectionType": "specific",
    "status":'confirmed'
  },

  {
    "specificSlot": {
      "startTime": "2025-05-28T09:15:00.000Z",
      "endTime": "2025-05-28T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593767", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-05-29T09:15:00.000Z",
      "endTime": "2025-05-29T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593761", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-05-30T09:15:00.000Z",
      "endTime": "2025-05-30T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593762", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-05-01T09:15:00.000Z",
      "endTime": "2025-05-01T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593763", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-05-02T09:15:00.000Z",
      "endTime": "2025-05-02T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593764", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-05-03T09:15:00.000Z",
      "endTime": "2025-05-03T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593765", 
    "slotSelectionType": "specific",
  },

  {
    "specificSlot": {
      "startTime": "2025-06-28T09:15:00.000Z",
      "endTime": "2025-06-28T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593767", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-06-29T09:15:00.000Z",
      "endTime": "2025-06-29T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593761", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-06-30T09:15:00.000Z",
      "endTime": "2025-06-30T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593762", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-06-01T09:15:00.000Z",
      "endTime": "2025-06-01T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593763", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-06-02T09:15:00.000Z",
      "endTime": "2025-06-02T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593764", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-06-03T09:15:00.000Z",
      "endTime": "2025-06-03T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593765", 
    "slotSelectionType": "specific",
  },
  

  {
    "specificSlot": {
      "startTime": "2025-10-28T09:15:00.000Z",
      "endTime": "2025-10-28T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593767", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-10-29T09:15:00.000Z",
      "endTime": "2025-10-29T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593761", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-10-30T09:15:00.000Z",
      "endTime": "2025-10-30T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593762", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-10-01T09:15:00.000Z",
      "endTime": "2025-10-01T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593763", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-10-02T09:15:00.000Z",
      "endTime": "2025-10-02T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593764", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-10-03T09:15:00.000Z",
      "endTime": "2025-10-03T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593765", 
    "slotSelectionType": "specific",
  },


  {
    "specificSlot": {
      "startTime": "2025-11-28T09:15:00.000Z",
      "endTime": "2025-11-28T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593767", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-11-29T09:15:00.000Z",
      "endTime": "2025-11-29T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593761", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-11-30T09:15:00.000Z",
      "endTime": "2025-11-30T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593762", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-11-01T09:15:00.000Z",
      "endTime": "2025-11-01T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593763", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-11-02T09:15:00.000Z",
      "endTime": "2025-11-02T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593764", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-11-03T09:15:00.000Z",
      "endTime": "2025-11-03T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593765", 
    "slotSelectionType": "specific",
  },

  


  {
    "specificSlot": {
      "startTime": "2025-12-28T09:15:00.000Z",
      "endTime": "2025-12-28T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593767", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-12-29T09:15:00.000Z",
      "endTime": "2025-12-29T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593761", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-12-30T09:15:00.000Z",
      "endTime": "2025-12-30T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593762", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-12-01T09:15:00.000Z",
      "endTime": "2025-12-01T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593763", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-12-02T09:15:00.000Z",
      "endTime": "2025-12-02T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593764", 
    "slotSelectionType": "specific",
  },
  {
    "specificSlot": {
      "startTime": "2025-12-03T09:15:00.000Z",
      "endTime": "2025-12-03T10:15:00.000Z"
    },
     "_id": "69247988435c284e97593765", 
    "slotSelectionType": "specific",
  }
];


export const Months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]